
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover",
      function () {
        return require("private-next-pages/discover/index.js");
      }
    ]);
  